import React from "react";
import { IconEmpty, IconRefresh, IconWarning } from "./icons";
import Button from "./Button";

/** Empty state: briefly says what happened and what to try. */
export function EmptyState({ icon: Icon = IconEmpty, title = "Nema podataka", hint, className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-1.5 px-4 py-8 text-center ${className}`}>
      <Icon aria-hidden="true" className="text-3xl text-slate-300 dark:text-slate-600" />
      <p className="text-sm font-medium text-slate-700 dark:text-slate-200">{title}</p>
      {hint && <p className="max-w-xs text-xs text-slate-500 dark:text-slate-400">{hint}</p>}
    </div>
  );
}

/** Load error: a clear message and a retry button. */
export function ErrorState({
  title = "Podaci nisu učitani",
  message = "Server nije vratio odgovor. Proveri vezu i pokušaj ponovo.",
  onRetry,
  className = "",
}) {
  return (
    <div role="alert" className={`flex flex-col items-center justify-center gap-1.5 px-4 py-8 text-center ${className}`}>
      <IconWarning aria-hidden="true" className="text-3xl text-danger dark:text-danger-light" />
      <p className="text-sm font-medium text-slate-800 dark:text-slate-100">{title}</p>
      <p className="max-w-xs text-xs text-slate-500 dark:text-slate-400">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" icon={IconRefresh} onClick={onRetry} className="mt-2">
          Pokušaj ponovo
        </Button>
      )}
    </div>
  );
}
